import { HorizontalBar } from 'vue-chartjs'

export default {
	extends: HorizontalBar,
	props: ['orderField', 'sort', 'companies', 'brands', 'salesChannel', 'date', 'update'],
	data () {
		return {
			dataset: {},
			isRendered: false
		}
	},
	computed: {
		chartData () {
			return this.dataset
		},
		options () {
			return {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: true
				},
				responsive: true,
				maintainAspectRatio: true
			}
		}
	},
	methods: {
		getData () {
			this.$emit('loading')
			if (this.isRendered) {
				this.$data._chart.destroy()
			}
			API.get(this.formUrl())
				.then(res => {
					this.dataset = res.data
					this.$emit(this.dataset.datasets.length === 0 ? 'noData' : 'yesData')
					this.$emit('finished')
				})
		},
		formUrl () {
			let url = `ecommerce/sales-statistics/brands?start=${this.date.split('#')[0]}&end=${this.date.split('#')[1]}`
			url += `&brands=${this.update ? this.update : this.brands.length > 0 ? this.brands.join(',') : ''}`
			url += `&salesChannel=${this.salesChannel}`
			url += `&orderDirection=${this.sort}`
			this.orderField ? url += `&orderField=${this.orderField}` : ''
			url += `&companyIDs=${this.companies}`
			return url
		}
	},
	mounted () {
		API.get(this.formUrl())
			.then(res => {
				this.dataset = res.data
				if (this.dataset.datasets.length === 0) {
					this.$emit('noData')
				}
				this.isRendered = true
				this.$emit('finished')
				this.$emit('updateSubcats', res.data.labels)
			})
	},
	watch: {
		companies () {
			this.getData()
		},
		dataset () {
			this.renderChart(this.dataset, this.options)
		},
		group () {
			this.getData()
		},
		date () {
			this.getData()
		},
		salesChannel () {
			this.getData()
		},
		brands () {
			this.getData()
		},
		orderField () {
			this.getData()
		},
		sort () {
			this.getData()
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/BrandsStatsChart.js